
const initialStateSave = {
  showModal: false,
};

export function saveRentalVehicle(state = initialStateSave, action) {
  switch(action.type) {
    case 'SAVE_RENTAL_VEHICLE.SUCCESS':
      return {
        ...state
      };
    case 'HIDE_RENTAL_MODAL':
      return {
        ...state,
        showModal: false,
      };
    case 'SHOW_RENTAL_MODAL':
      return {
        ...state,
        showModal: true,
      };
    default:
      return state
  }
}

export function updateRentalVehicle(state = initialStateSave, action) {
  switch(action.type) {
    case 'UPDATE_RENTAL_VEHICLE.SUCCESS':
      return {
        ...state
      };
    default:
      return state;
  }
}

export function deleteRentalVehicle(state = initialStateSave, action) {
  switch(action.type) {
    case 'DELETE_RENTAL_VEHICLE.SUCCESS':
      return {
        ...state
      };
    default:
      return state;
  }
}

export function assignRentalVehicle(state = initialStateSave, action) {
  switch(action.type) {
    case 'ASSIGN_RENTAL_VEHICLE.SUCCESS': {
      return {
        ...state
      };
    }
    case 'HIDE_ASSIGN_MODAL':
      return {
        ...state,
        showModal: false
      };
    case 'SHOW_ASSIGN_MODAL':
      return {
        ...state,
        showModal: true
      };
    default:
      return state
  }
}

export function lookupIvsVin(state = initialStateSave, action) {
  switch(action.type) {
    case 'LOOKUP_IVS_VIN.SUCCESS':
      return {
          ...state,
          items: action.ivsResults.body,

      };
    default:
      return state;
  }
}
